import React from 'react';

import leftovers from './AppShellLeftovers.module.css';
import {
  chunkErrorMessage,
  chunkErrorReloadLabel,
} from '../chunkErrorFallbackText';

interface ChunkErrorFallbackProps {
  onReload: () => void;
}

// Plain-markup fallback shown when a load error can't be auto-recovered. Shared
// by AppErrorBoundary (which renders outside the Mantine provider) and the route
// errorElement, so it uses no Mantine components. Its strings come from
// chunkErrorFallbackText, which stays English until a candidate app registers
// i18next, so this file never imports the i18next runtime into the entry chunk.
export const ChunkErrorFallback: React.FC<ChunkErrorFallbackProps> = ({
  onReload,
}) => (
  <div className={leftovers.chunkFallback}>
    <div>{chunkErrorMessage()}</div>
    <button
      type='button'
      onClick={onReload}
      className={leftovers.chunkReloadBtn}
    >
      {chunkErrorReloadLabel()}
    </button>
  </div>
);
